import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="relative w-full bg-background-950 text-background-200 pt-16 pb-8">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-semibold text-background-50">
                USFans <span className="text-primary-400">Wiki</span>
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              USFans Wiki to polska baza wiedzy o USFans Spreadsheet — narzędziu do analizy twórców i zarządzania kampaniami dla agencji.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">Szybkie linki</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">
                  Strona główna
                </Link>
              </li>
              <li>
                <Link to="/artykul/usfans-spreadsheet-kompletny-przewodnik-2026" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">
                  Poradnik USFans Spreadsheet
                </Link>
              </li>
              <li>
                <a href={`${mainSiteUrl}`} target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">
                  USFans Spreadsheet
                </a>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">Kategorie</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">Zasoby</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">
                  Polityka prywatności
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">
                  Regulamin
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between pt-8 border-t border-background-800 gap-4">
          <p className="text-xs text-background-500">
            © 2026 USFans Wiki. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-6">
            <a
              href={`${mainSiteUrl}`}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200"
            >
              USFans Spreadsheet na Kaspreadsheet
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}